import { render, staticRenderFns } from "./LogDetailComponent.vue?vue&type=template&id=20461ab3"
import script from "./LogDetailComponent.vue?vue&type=script&lang=js"
export * from "./LogDetailComponent.vue?vue&type=script&lang=js"
import style0 from "./LogDetailComponent.vue?vue&type=style&index=0&id=20461ab3&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports